import { SearchX, SlidersHorizontal } from "lucide-react";

import type { Notification, NotificationConfigContext } from "../types";
import { NotificationObjectMosaic } from "./NotificationObjectMosaic";

function EmptyState({
  hasActiveFilter,
  onClearFilter,
}: {
  hasActiveFilter: boolean;
  onClearFilter: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14">
      <div className="mb-5 flex size-12 items-center justify-center rounded-xl bg-muted/80 ring-1 ring-inset ring-border/50">
        {hasActiveFilter ? (
          <SlidersHorizontal className="size-5 text-muted-foreground" aria-hidden />
        ) : (
          <SearchX className="size-5 text-muted-foreground" aria-hidden />
        )}
      </div>
      <p className="text-sm font-normal text-foreground">
        {hasActiveFilter ? "No results for this filter" : "No updates yet"}
      </p>
      <p className="mt-1 max-w-[20rem] text-center text-sm font-normal leading-relaxed text-muted-foreground">
        {hasActiveFilter
          ? "Try removing some filters or broadening your search to see more."
          : "When activity happens across your boards, updates will show up here."}
      </p>
      {hasActiveFilter ? (
        <button
          type="button"
          onClick={onClearFilter}
          className="mt-4 rounded-full bg-foreground/10 px-4 py-1.5 text-xs font-medium text-foreground/80 transition-colors duration-150 hover:bg-foreground/15"
        >
          Clear filters
        </button>
      ) : null}
    </div>
  );
}

export function NotificationAllView({
  notifications,
  context,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
  onFetchNextPage,
  onClearFilter,
  hasActiveFilter,
}: {
  notifications: Notification[];
  context: NotificationConfigContext;
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
  onFetchNextPage: () => void;
  onClearFilter: () => void;
  hasActiveFilter: boolean;
}) {
  return (
    <NotificationObjectMosaic
      notifications={notifications}
      context={context}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isLoading}
      onFetchNextPage={onFetchNextPage}
      empty={
        <EmptyState
          hasActiveFilter={hasActiveFilter}
          onClearFilter={onClearFilter}
        />
      }
    />
  );
}
